// extracted by mini-css-extract-plugin
export default {"formCard":"style_formCard__tUk1G","formCardHeader":"style_formCardHeader__7-38S","formCardContent":"style_formCardContent__KLFP8"};